import { getNumber } from './util';
export function saturate() {
  let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const amount = getNumber(args.amount, 1);
  return `
      <filter>
        <feColorMatrix type="saturate" values="${1 - amount}"/>
      </filter>
    `.trim();
}